import { render, staticRenderFns } from "./educationTargetUsersPop.vue?vue&type=template&id=b8e1f70c"
import script from "./educationTargetUsersPop.vue?vue&type=script&lang=js"
export * from "./educationTargetUsersPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e1f70c')) {
      api.createRecord('b8e1f70c', component.options)
    } else {
      api.reload('b8e1f70c', component.options)
    }
    module.hot.accept("./educationTargetUsersPop.vue?vue&type=template&id=b8e1f70c", function () {
      api.rerender('b8e1f70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/educationTargetUsersPop.vue"
export default component.exports